import React from 'react'
import NotFound from '../../components/error-pages/NotFound'

export function NoMatch() {
  return <NotFound />
}
